import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = {
  class: "registration-chips",
  slot: "end"
}
const _hoisted_4 = {
  key: 0,
  class: "ion-text-center registrations-empty"
}
const _hoisted_5 = { class: "scanner-wrapper" }
const _hoisted_6 = {
  ref: "scannerVideo",
  class: "scanner-video",
  playsinline: "",
  muted: "",
  autoplay: ""
}
const _hoisted_7 = {
  ref: "scannerCanvas",
  class: "scanner-canvas"
}
const _hoisted_8 = { class: "scan-result-icon" }
const _hoisted_9 = { class: "scan-result-text" }
const _hoisted_10 = {
  key: 0,
  class: "scan-result-user"
}
const _hoisted_11 = {
  key: 1,
  class: "scanner-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_HeaderMessengerButton = _resolveComponent("HeaderMessengerButton")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/admin-events"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.event?.title || 'Регистрации'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                slot: "end",
                class: "registrations-header-actions"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_HeaderMessengerButton),
                  _createVNode(_component_ion_button, {
                    "aria-label": "Сканер QR",
                    onClick: _ctx.onOpenScannerClick
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.qrCodeOutline,
                        slot: "icon-only"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }, 8, ["onIonRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка..."))
              : (_openBlock(), _createBlock(_component_ion_list, {
                  key: 1,
                  lines: "full",
                  class: "registrations-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registrations, (r) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        key: r.id,
                        class: "registration-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", null, _toDisplayString(r.userFirstName) + " " + _toDisplayString(r.userLastName), 1),
                              _createElementVNode("p", null, _toDisplayString(r.userLogin) + " · " + _toDisplayString(r.userEmail), 1),
                              _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(r.registeredAt)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_3, [
                            (_ctx.event?.isPaid)
                              ? (_openBlock(), _createBlock(_component_ion_badge, {
                                  key: 0,
                                  color: r.paid ? 'success' : 'warning'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(r.paid ? 'Оплачено' : 'Не оплачено'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_badge, {
                              color: r.checkedInAt ? 'success' : 'medium'
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(r.checkedInAt ? `Вход ${_ctx.formatCheckInTime(r.checkedInAt)}` : 'Не отмечен'), 1)
                              ]),
                              _: 2
                            }, 1032, ["color"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (_ctx.registrations.length === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Нет регистраций."))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
          ]),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.showScanner,
            onDidDismiss: _ctx.onScannerClose,
            onIonDidPresent: _ctx.onScannerPresent,
            class: "qr-scanner-modal",
            "initial-breakpoint": 1,
            breakpoints: [0, 1]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, { class: "scanner-header" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("Сканирование QR-кода", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            class: "scanner-close-btn",
                            onClick: _ctx.onScannerClose
                          }, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                              _createTextVNode("Закрыть", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_content, {
                class: "scanner-content",
                fullscreen: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("video", _hoisted_6, null, 512),
                    _createElementVNode("canvas", _hoisted_7, null, 512),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "scanner-overlay" }, [
                      _createElementVNode("div", { class: "scanner-frame" }),
                      _createElementVNode("p", { class: "scanner-hint" }, "Наведите камеру на QR-код участника")
                    ], -1))
                  ]),
                  (_ctx.scanResult !== null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["scan-result-overlay", _ctx.scanResult.success ? 'success' : 'fail'])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.scanResult.success)
                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 0,
                                icon: _ctx.checkmarkCircleOutline
                              }, null, 8, ["icon"]))
                            : (_openBlock(), _createBlock(_component_ion_icon, {
                                key: 1,
                                icon: _ctx.closeCircleOutline
                              }, null, 8, ["icon"]))
                        ]),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.scanResult.message), 1),
                        (_ctx.scanResult.user)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.scanResult.user), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          class: "scan-result-rescan-btn",
                          size: "small",
                          fill: "outline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.scanResult = null; _ctx.startCamera()})
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Сканировать ещё", -1)
                          ]))]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.cameraError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.cameraError), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss", "onIonDidPresent"])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}